import { axiosRequestGET } from "./serviceConfig";

export const getLogoutThresholds = () =>
  axiosRequestGET("/api/champ/logout-thresholds");